import { z } from "zod";

export const updateEventStructureTicketAlertSchema = z
  .object({
    hasTicketAlertThreshold: z.boolean(),
    ticketAlertThreshold: z.coerce.number().nullable().optional(),
  })
  .refine(
    ({ hasTicketAlertThreshold, ticketAlertThreshold }) =>
      !hasTicketAlertThreshold ||
      (ticketAlertThreshold && ticketAlertThreshold >= 1),
    {
      message: "Le seuil d'alerte doit être défini et supérieur ou égal à 1",
      path: ["ticketAlertThreshold"],
    }
  );

export type UpdateEventStructureTicketAlertForm = z.infer<
  typeof updateEventStructureTicketAlertSchema
>;

export const defaultUpdateEventStructureValues: UpdateEventStructureTicketAlertForm =
  {
    hasTicketAlertThreshold: false,
    ticketAlertThreshold: 0,
  };
